import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Category from "./pages/Category";
import Price from "./pages/Price";
import './index.css'
import ErrorMessage from "./ErrorMessage";
import Polotno from "./polotno";
import Catelog from "./AuthPages/Catelog";
import AuthResumeMaker from "./AuthPages/resumemaker";
import AuthLogoMaker from "./AuthPages/logoMaker";
import AuthEmployeeMaker from "./AuthPages/employecertificate";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUSPage from "./pages/Contactus";
import BecomePartener from "./pages/BecomePartener";
import PromotionMaker from "./AuthPages/promotionMaker";
import SpecificResumeBuilder from "./ResumeBuilder/pages/specificbuilder/page";
import AuthBirthdayCards from "./AuthPages/BirthdayCards"; 
import VideoEditor from "./VideoEditor/app/page";
import AuthWeddingcards from "./AuthPages/WeddingCard"; 
import AuthCVMaker from "./AuthPages/CvMaker"; 
import AuthCoverLetter from "./AuthPages/CoverLetter";
import EditorPage from "./VideoEditor/app/editor/page";
import { createStore } from 'polotno/model/store';
import { unstable_setAnimationsEnabled } from 'polotno/config';
import { createProject, ProjectContext } from './project';
import { ErrorBoundary } from 'react-error-boundary';
import CoverPageBuilder from "./CoverPageBuilder/page";
import AboutUs from "./pages/AboutUs";
import TermsOfUse from "./pages/TermsOfUse";
import TermsAndConditions from "./pages/TermConditions";
import { Router } from "./DeveloperPanel/Routes/routes";
import Templates from "./DeveloperPanel/Pages/templates";
import Setting from "./DeveloperPanel/Pages/setting";
import Account from './DeveloperPanel/Pages/account';
import Payments from "./DeveloperPanel/Pages/payments";
import WhatsAppChat from "./components/whatsappbutton";

unstable_setAnimationsEnabled(true);
const store = createStore({ key: 'nFA5H9elEytDyPyvKL7T' });
window.store = store;
store.addPage();
const project = createProject({ store });
window.project = project;
// const root = ReactDOM.createRoot(document.getElementById('root'));

function Fallback() {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <div style={{ textAlign: 'center', paddingTop: '40px' }}>
        <p>Something went wrong in the app.</p>
        <p>Try to reload the page.</p>
        <p>If it does not work, clear cache and reload.</p>
        <button
          onClick={async () => {
            await project.clear();
            window.location.reload();
          }}
        >
          Clear cache and reload
        </button>
      </div>
    </div>
  );
}




const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorMessage />,
    children: [
      {
        path: "",
        element: <Home />
      },
      {
        path: "category/:val/:category",
        element: <Category />
      },
      {
        path: "price",
        element: <Price />
      }, {
        path: "resumeMaker/:text/:category",
        element: <Polotno propName={`${store}`} />
      }, {
        path: "TermsandCondition",
        element: <TermsAndConditions />
      },{
        path: "Catelog",
        element: <Catelog />
      },
      {
        path: "AboutUs",
        element: <AboutUs />
      },
      {
        path: "PromotionMaker",
        element: <PromotionMaker />
      },
      {
        path: "TermsOfUse",
        element: <TermsOfUse />
      },
      {
        path: "BecomePartener",
        element: <BecomePartener />
      },
      {
        path: "ResumeMaker",
        element: <AuthResumeMaker />
      },
      {
        path: "LogoMaker",
        element: <AuthLogoMaker />
      },
      {
        path: "EmployeeCertificate",
        element: <AuthEmployeeMaker />
      },
      {
        path: "PrivacyPolicy",
        element: <PrivacyPolicy />
      },
      {
        path: "CVMaker",
        element: <AuthCVMaker />
      },
      {
        path: "CoverLetter",
        element: <AuthCoverLetter />
      },
      {
        path: "BirthdayCards",
        element: <AuthBirthdayCards />
      },
      {
        path: "Weddingcards",
        element: <AuthWeddingcards />
      },
      {
        path: "ContactusPage",
        element: <ContactUSPage />
      },
      {
        path:"/pages/specificbuilder/:id",
        element: < SpecificResumeBuilder/>
      },
      {
        path:"/CoverBuilder/:id",
        element: <CoverPageBuilder />
      },
      {
        path:"/VideoEditor",
        element: <VideoEditor />
      },
      {
        path:"/editor",
        element: <EditorPage />
      },{
        path:"/DeveloperPanel",
        element: <Router />
      },
      {
        path: '/Templates',
        element: <Templates />,
      },
      {
        path:'/Payments',
        element: <Payments/>
      },
     
      {
        path: '/Setting',
        element: <Setting />,
      },
      {
        path: '/account',
        element: <Account />,  // Using 'Account' from account.jsx
      },
      
    ]
  },
]
);

  function App() {
    return (

            <ErrorBoundary
            FallbackComponent={Fallback}
            onReset={(details) => {
            }}
            onError={(e) => {
              if (window.Sentry) {
                window.Sentry.captureException(e);
              }
            }}
          >
            <WhatsAppChat/>
            <ProjectContext.Provider value={project}>
            <RouterProvider router={router} />

            </ProjectContext.Provider>
          </ErrorBoundary>

    )
  }

export default App
